/* eslint-disable react/jsx-wrap-multilines */
import { color, Common } from '@stockbit/ui';
import { useState } from 'react';
import { InputContainer, Input } from './styled';

const { Text } = Common;

interface PollingInputChoiceProps {
  iconRemove?: () => any;
  onChange?: (val: any) => any;
  [key: string]: any;
}

function PollingInputChoice({ iconRemove, onChange, ...otherProps }: PollingInputChoiceProps) {
  const [maxCharLabel, setMaxCharLabel] = useState(25);
  const maxChar = 25;
  const subtract = (varible, constant) => constant - varible;

  const suffix = (
    <Text size="14px" color={color.midgray}>
      {maxCharLabel}
    </Text>
  );

  return (
    <InputContainer>
      <Input
        {...otherProps}
        onChange={(e) => {
          onChange(e);
          setMaxCharLabel(subtract(e.currentTarget.value.length, maxChar));
        }}
        maxLength={maxChar}
        height="40px"
        mb="14px"
        width="100%"
        suffix={suffix}
      />
      {iconRemove && iconRemove()}
    </InputContainer>
  );
}

export default PollingInputChoice;
